import { render } from "./NotFound.vue?vue&type=template&id=51738bf8&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=51738bf8&scoped=true&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51738bf8"]])

export default __exports__